import ApiCore from './api-core'
import { PUBLIC } from '@/constants/api-types'

export default class Car extends ApiCore {
  constructor(store) {
    const path = `${PUBLIC}/car`
    super(store, path)
  }

  brandList(filter, showProgress) {
    return this.request({
      action: 'brand/list',
      method: 'GET',
      params: filter,
      showProgress
    })
  }

  typeList(filter, showProgress) {
    return this.request({
      action: 'type/list',
      method: 'GET',
      params: filter,
      showProgress
    })
  }
}
